import { useEffect } from "react";

/** Per-page metadata. Sets document.title, meta description, robots
 *  (if provided) on mount and restores previous values on unmount so the
 *  global SEOHead defaults resume on other pages. Also initialises
 *  window.dataLayer if not present. */
export function usePageMeta({ title, description, noindex = false }) {
  useEffect(() => {
    const prevTitle = document.title;
    const descEl = document.querySelector('meta[name="description"]');
    const prevDesc = descEl ? descEl.getAttribute("content") : null;

    if (title) document.title = title;
    if (description) {
      let el = document.querySelector('meta[name="description"]');
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", "description");
        document.head.appendChild(el);
      }
      el.setAttribute("content", description);
    }

    let robotsEl = document.querySelector('meta[name="robots"]');
    let createdRobots = false;
    if (noindex) {
      if (!robotsEl) {
        robotsEl = document.createElement("meta");
        robotsEl.setAttribute("name", "robots");
        document.head.appendChild(robotsEl);
        createdRobots = true;
      }
      robotsEl.setAttribute("content", "noindex, nofollow");
    }

    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
    }

    return () => {
      document.title = prevTitle;
      if (descEl && prevDesc !== null) descEl.setAttribute("content", prevDesc);
      if (noindex && robotsEl) {
        if (createdRobots) robotsEl.remove();
        else robotsEl.setAttribute("content", "index, follow");
      }
    };
  }, [title, description, noindex]);
}

/** Push a dataLayer event, initialising the queue if needed.
 *  Also fires a matching `gtag('event', ...)` when gtag.js is present so
 *  GA4 (which reads through gtag, not raw dataLayer objects) records it. */
export function pushDataLayer(event, params = {}) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", event, params);
    }
  } catch (_) { /* never let analytics break the app */ }
}
